import Login from './components/auth/Login'
import TermReports from './components/TermReports'
import CSECSubjectSelection from './components/CSECSubjectSelection'
import Dashboard from './components/Dashboard.vue'
//import Logout from './components/auth/Logout'

const routes = [
  { 
      path: '/',
      name: 'login', 
      component: Login,
      meta: {
        requiresVisitor: true,
      }
  },
  {
    path: '/term-reports',
    name: 'termReports',
    component: TermReports,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/csec-subject-selection',
    name: 'csecSubjectSelection',
    component: CSECSubjectSelection,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: '*',
  //   component: NotFoundComponent
  // }  
]

export default routes